import FormControl from "@material-ui/core/FormControl/FormControl"
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel"
import Radio from "@material-ui/core/Radio/Radio"
import RadioGroup from "@material-ui/core/RadioGroup"

const TrueFalseQuestion = ({
  question: { title, options = [], user_answer_options = [] },
  questionIdx,
  isCompleted,
  onChange,
}) => {
  return (
    <div className="full-width" key={questionIdx}>
      <div className="form__fieldset">
        <label htmlFor={`field_${questionIdx}`} className="form__label">
          Question {questionIdx + 1}
        </label>
        <div className="form__fieldbox">
          <div className="form__masked-value">
            <pre>{title}</pre>
          </div>
        </div>
      </div>
      <div className="form__fieldset">
        <label htmlFor={`field_${questionIdx}`} className="form__label">
          Answer
        </label>
        <div className="form__fieldbox">
          <div className="form__input">
            <FormControl
              component="fieldset"
              id="group-type"
              disabled={isCompleted}
            >
              <RadioGroup aria-label="group-type" name="groupType">
                {options.map((v, optionIdx) => {
                  return (
                    <FormControlLabel
                      key={v}
                      checked={user_answer_options?.includes(optionIdx)}
                      control={
                        <Radio
                          color="primary"
                          onChange={(e) => onChange(e, questionIdx, optionIdx)}
                        />
                      }
                      label={<pre>{v}</pre>}
                      labelPlacement="end"
                    />
                  )
                })}
              </RadioGroup>
            </FormControl>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TrueFalseQuestion
